import styled from "styled-components";

export const VariationLevelContainer = styled.div`
  margin-bottom: 2rem;

  .level-select-row {
    display: flex;
    align-items: flex-end;
    gap: 1.5rem;

    .view-select {
      flex: 1;
      min-width: 20rem;
    }

  }

  .level-tags-row {
    margin-top: 1rem;
  }

  .level-change-type-row {
    display: flex;
    align-items: flex-end;
    gap: 1.5rem;
    margin-top: 1rem;

    .selectComponentContainer {
      flex: 1;
      min-width: 20rem;
    }

    .cancel-change {
      cursor: pointer;
      color: ${(props) => props.theme.colors.tertiary};
      white-space: nowrap;
      padding-bottom: 1rem;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
